import React from 'react';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';

interface ImageContentProps {
  content: Array<string> | string;
}

const ImageContent: React.FC<ImageContentProps> = ({content}) => {
  const baseAssetPath = window.location.origin;
  if (Array.isArray(content)) {
    return (<Text tag='ul'>
      {content.map((imgPath) => <li><img src={`${baseAssetPath}${imgPath}`} alt={imgPath} width={250} /></li>)}
    </Text> );
  }
  return (
    <Row>
      <img src={`${baseAssetPath}${content}`} alt={content} width={250} />
    </Row>
  );
};

export default ImageContent;